<template>
  <div>


    <div class="d-flex align-center flex-wrap gap my-3">
      <div class="text-h6 font-weight-bold">{{ parcours_name }}</div>

      <v-chip v-if="inscriptionStatus" elevation="0" :color="chipStatusColor" variant="flat">{{
        inscriptionStatus }}</v-chip>
    </div>

    <v-alert v-if="inscriptionNotEditable" border="start" class="my-2" border-color="red-darken-4" elevation="0">
      <span v-if="inscriptionTransfered">Vous n'avez plus accès à cette inscription car
        elle a été transférée à un autre participant via le formulaire de transfert.</span>
      <span v-if="inscriptionDeleted">Vous n'avez plus accès à cette inscription car
        elle a été supprimée. Cela peut faire suite à une demande de remboursement ou une intervention de
        l'organisateur.</span>
      <span v-if="inscriptionSold">Vous n'avez plus accès à cette inscription car elle
        a été vendue sur la bourse aux dossards.</span>
    </v-alert>

    <div v-else>
      <div v-if="mainStore.module.base == 'ROUCASS26'">
        <ROUCASS26KeepInscriptionHook :inscription="inscription"></ROUCASS26KeepInscriptionHook>
      </div>
      <div v-if="mainStore.module.base == 'MAXIRACE26'">
        <MAXIRACE26RetraitDossardHook :inscription="inscription"></MAXIRACE26RetraitDossardHook>
      </div>
      <div v-if="mainStore.module.base == 'SUPERBESSE_TRIATH26' && showSuperbesseTriath26KeepInscriptionHook">
        <SUPERBESSE_TRIATH26KeepInscriptionHook :inscription="inscription"></SUPERBESSE_TRIATH26KeepInscriptionHook>
      </div>
      <div v-if="mainStore.module.base == 'LCE26' && showLCE26PerformanceHook">
        <LCE26PerformanceHook :inscription="inscription"></LCE26PerformanceHook>
      </div>
      <!-- <div v-if="mainStore.module.base == 'LUCIO26' && inscription.id <= 305563">
        <LUCIO26KeepInscriptionHook :inscription="inscription"></LUCIO26KeepInscriptionHook>
      </div> -->
      <ActionCardInscription :inscription="inscription" :all_commande_inscription="all_commande_inscription" :gia="gia"
        :alerte_sms="alerte_sms" :is_free_commande="is_free_commande">
      </ActionCardInscription>
    </div>
  </div>
</template>

<script>
const statutsInscription = {
  TRANSFERRED: 'Transférée',
  DELETED: 'Annulée',
  LISTED: 'En cours de vente',
  SOLD: 'Vendue',
  NOT_PAID: 'Non payée',
  DOCUMENT_NOT_RECEIVED: 'Document non reçu',
  DOCUMENT_VALIDATION_IN_PROGRESS: 'Document en cours de validation',
  PENDING_VALIDATION: 'En attente de validation',
  VALIDATED: 'Validée',
}
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ActionCardInscription from "./ActionCardInscription.vue";
import ROUCASS26KeepInscriptionHook from "../Hooks/ROUCASS26_keep_inscription.vue";
import MAXIRACE26RetraitDossardHook from "../Hooks/MAXIRACE26_retrait_dossard.vue";
import SUPERBESSE_TRIATH26KeepInscriptionHook from "../Hooks/SUPERBESSE_TRIATH26_keep_inscription.vue";
import LCE26PerformanceHook from "../Hooks/LCE26_Performance.vue";
export default {
  components: {
    ActionCardInscription,
    ROUCASS26KeepInscriptionHook,
    MAXIRACE26RetraitDossardHook,
    SUPERBESSE_TRIATH26KeepInscriptionHook,
    LCE26PerformanceHook,
  },
  data() {
    return {
      base_url: process.env.VUE_APP_API_BASE,
      inscription: {},
    };
  },
  props: ["item", "all_commande_inscription", "gia", "alerte_sms", 'is_free_commande'],
  computed: {
    ...mapStores(useMainStore),
    parcours_name() {
      const vague = this?.inscription?.vague && this?.inscription?.vague != '' ? ' (Vague ' + this?.inscription?.vague + ')' : '';
      return this?.inscription?.course?.nom + vague;
    },
    inscriptionNotEditable() {
      return this.inscriptionStatus == statutsInscription.TRANSFERRED || this.inscriptionStatus == statutsInscription.DELETED || this.inscriptionStatus == statutsInscription.SOLD;
    },
    inscriptionTransfered() {
      return this.inscriptionStatus == statutsInscription.TRANSFERRED;
    },
    inscriptionDeleted() {
      return this.inscriptionStatus == statutsInscription.DELETED;
    },
    inscriptionSold() {
      return this.inscriptionStatus == statutsInscription.SOLD;
    },

    inscriptionStatus() {
      let status = null;
      const inscription = this.inscription;

      if (!inscription) {
        return status;
      }
      if (inscription?.bourse_dossards_status == 'PENDING') {
        status = statutsInscription.LISTED;
        return status;
      }
      if (inscription?.bourse_dossards_status == 'PAID') {
        status = statutsInscription.SOLD;
        return status;
      }
      if (inscription.transfere == 1) {
        status = statutsInscription.TRANSFERRED;
        return status;
      }
      if (inscription.supprime == 1) {
        status = statutsInscription.DELETED;
        return status;
      }

      if (inscription.paye == 0) {
        status = statutsInscription.NOT_PAID;
        return status;
      }
      if (inscription.document_recu == 0) {
        status = statutsInscription.DOCUMENT_NOT_RECEIVED;
        return status;
      }
      if (inscription.document_valide == 0) {
        status = statutsInscription.DOCUMENT_VALIDATION_IN_PROGRESS;
        return status;
      }
      if (inscription.valide == 0) {
        status = statutsInscription.PENDING_VALIDATION;
        return status;
      }
      if (inscription.valide == 1) {
        status = statutsInscription.VALIDATED;
        return status;
      }
      return status;
    },
    /** Visible jusqu’au 24 mai 2026 inclus (masqué à partir du 25 à 00:00 heure locale). */
    showSuperbesseTriath26KeepInscriptionHook() {
      const finAffichage = new Date("2026-05-22T11:59:00");
      return new Date() < finAffichage;
    },
    showLCE26PerformanceHook() {
      const debutAffichage = new Date("2026-09-14T11:59:00");
      const finAffichage = new Date("2026-09-26T11:59:00");
      return new Date() > debutAffichage && new Date() < finAffichage;
    },
    chipStatusColor() {
      if (this.inscriptionStatus == statutsInscription.LISTED) {
        return "primary-dark";
      }
      if (this.inscriptionStatus == statutsInscription.SOLD) {
        return "red-darken-4";
      }
      if (this.inscriptionStatus == statutsInscription.NOT_PAID) {
        return "red-darken-4";
      }
      if (this.inscriptionStatus == statutsInscription.DOCUMENT_NOT_RECEIVED) {
        return "red-darken-4";
      }
      if (this.inscriptionStatus == statutsInscription.DOCUMENT_VALIDATION_IN_PROGRESS) {
        return "primary-dark";
      }
      if (this.inscriptionStatus == statutsInscription.PENDING_VALIDATION) {
        return "red-darken-4";
      }
      if (this.inscriptionStatus == statutsInscription.VALIDATED) {
        return "green-darken-4";
      }

      return "darkblue";
    },



  },
  methods: {
  },
  created() {
    this.inscription = this.item;
  },
};
</script>

<style lang="scss" scoped></style>